import { render, staticRenderFns } from "./GoodTable.vue?vue&type=template&id=48f55aab&scoped=true&"
import script from "./GoodTable.vue?vue&type=script&lang=js&"
export * from "./GoodTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f55aab",
  null
  
)

export default component.exports